<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Kozijnen laten vervangen</h1>

      <p>
        Als je hebt besloten om nieuwe
        <nuxt-link to="/"> kozijnen </nuxt-link> aan te schaffen, sta je voor
        meerdere keuzes. Zo moeten bijvoorbeeld de volgende vragen worden
        beantwoord:
      </p>

      <ul>
        <li>
          Ga je zelf je kozijnen vervangen of laat je het over aan vakmensen?
        </li>
        <li>Wat voor soort kozijnen ga je kopen?</li>
        <li>Bij welke specialist koop je je nieuwe kozijnen?</li>
      </ul>

      <p>
        Op deze drie vragen krijg je stuk voor stuk antwoord in dit artikel op
        <nuxt-link to="/"> Kozijnenvergelijker.nl </nuxt-link>. Laat je goed
        informeren voordat je kozijnen vervangen worden!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Kozijnen vervangen? GRATIS offertes voor kozijnen vervangen!',
      headDescription:
        'Ben je van plan om jouw kozijnen te vervangen? Op Kozijnenvergelijker.nl lees je alles over kozijnen vervangen en vergelijk je gratis offertes!',
      path: '/informatie-over-kozijnen/vervangen',
    }
  },
}
</script>
